export default {"popover":"p3hrkG_popover","anchor":"p3hrkG_anchor","inheritTriggerWidth":"p3hrkG_inheritTriggerWidth",}